import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { paymentMethods } from "../../../../../../redux/payment-methods/action";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import { selectPaymentMethodsListItems } from "../../../../../../redux/payment-methods/selector";

const ManagementPaymentMethods = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const paymentMethodItems = useSelector(selectPaymentMethodsListItems)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'RazorPayConfigurationPId', headerName: 'RazorPay Configuration PId', searchField: 'RazorPayConfigurationPId', sortable: true, filter: true, filterType: 'text' },
      { field: 'GatewayName', headerName: 'Gateway Name', searchField: 'GatewayName', sortable: true, filter: true, filterType: 'text' },
      { field: 'GatewayKey', headerName: 'Gateway Key', searchField: 'GatewayKey', sortable: true, filter: true, filterType: 'text' },
      { field: 'IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const fetchPaymentMethods = async () => {
    await dispatch(paymentMethods.resetAction({ actionType: 'list' }))
    await dispatch(paymentMethods.list({
      url: `https://epay.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/configuration/payment-management/payment-methods/fetch`,
      entity: 'paymentMethods',
      jsonData:
      {
        Context: {},
        Records: [{ Id: 0 }],
        Pagination: {
          PageNumber: pageData,
          PageSize: pageSize,
          SortField: "CreatedOnUtc",
          SortOrder: "desc",
        }
      }
    }))
  }

  useEffect(() => {
    createColumnDefs();
    fetchPaymentMethods();
  }, [pageData, pageSize])

  const handleAdd = () => {
    navigate(`${0}`);
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.RazorPayConfigurationId}`);
  }

  const handleDelete = async (data: any) => {
    await dispatch(paymentMethods.resetAction({ actionType: 'delete' }))
    await dispatch(paymentMethods.delete({
      url: `https://epay.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/configuration/payment-management/payment-methods/delete`,
      entity: 'paymentMethods',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: data?.RazorPayConfigurationId
          }
        ]
      }
    })).then(() => {
      fetchPaymentMethods();
    });
  }

  const handleReloadData = () => {
    fetchPaymentMethods()
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Payment Methods</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = async (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    await dispatch(paymentMethods.resetAction({ actionType: 'list' }))
    await dispatch(paymentMethods.list({
      url: `https://epay.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/configuration/payment-management/payment-methods/fetch`,
      entity: 'paymentMethods',
      jsonData: {
        Context: {},
        Records: [{ Id: 0 }],
        Pagination: {
          PageNumber: pageData,
          PageSize: pageSize,
          SortField: "CreatedOnUtc",
          SortOrder: "desc",
          Searches: searchCriteria,
        }
      }
    }))
  }

  return (
    <>

      {paymentMethodItems?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={paymentMethodItems?.result?.items}
          setPageData={setPageData} setPageSize={setPageSize}
          paginationData={paymentMethodItems?.result?.pagination}
          enableFilter={true} onSearch={handleSearch}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'RazorPayConfigurationId',
          }}
          onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons}
          headingName="Payment Methods"
        />
      }
    </>
  );
}
export default ManagementPaymentMethods;


